var map = {
	"./regiligionsfreiheit_A1.png": 82060,
	"./regiligionsfreiheit_A2.png": 23696,
	"./regiligionsfreiheit_B1.png": 6772,
	"./regiligionsfreiheit_B2.png": 64244,
	"./regiligionsfreiheit_C1.png": 3691,
	"./regiligionsfreiheit_C2.png": 56729,
	"./regiligionsfreiheit_D1.png": 83613,
	"./regiligionsfreiheit_D2.png": 62958,
	"./regiligionsfreiheit_E1.png": 26538,
	"./regiligionsfreiheit_E2.png": 74803,
	"./regiligionsfreiheit_F1.png": 87667,
	"./regiligionsfreiheit_F2.png": 51407
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68210;